export default __webpack_public_path__ + "static/media/community.f4515c4e.svg";